import { memo } from "react";

type MarkdownHtmlProps = {
  htmlText: string;
};

export default memo(function MarkdownHtml({ htmlText }: MarkdownHtmlProps) {
  return (
    <div className="container mx-auto max-w-[1400px] px-6 py-16 md:px-12 md:py-32 lg:px-24">
      <div
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{ __html: htmlText }}
        className="legal-markdown space-y-4"
      />
      {/* This is a hack to force Tailwind classes to be applied. Without it the styles on MD stuff do not get applied */}
      <ul className="text-muted-foreground"></ul>
    </div>
  );
});
